import { Dropdown } from "react-bootstrap";
import {
  formatBookingAmount,
  getBookingStatusBadgeClass,
} from "../utils/booking.utils";

const BookingsTable = ({
  bookings,
  onViewDetails,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped align-middle">
        <thead>
          <tr>
            <th>Customer</th>
            <th>Vehicles</th>
            <th>Drivers</th>
            <th>Route</th>
            <th>Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking) => {
            const displayBookingId = booking?.bookingId || booking?._id || "-";
            const customerName = booking?.customerSnapshot?.name || booking?.fullName || "-";
            const companyName = booking?.customerSnapshot?.companyName || booking?.companyName || "-";
            const customerPhone = booking?.customerSnapshot?.phoneNumber || booking?.phoneNumber || "-";

            const bookingVehicles = Array.isArray(booking?.vehicles) ? booking.vehicles : [];
            const firstVehicle = bookingVehicles[0] || null;
            const firstVehicleLabel =
              firstVehicle?.snapshot?.name ||
              firstVehicle?.vehicleId?.name ||
              [firstVehicle?.snapshot?.make, firstVehicle?.snapshot?.model].filter(Boolean).join(" ") ||
              [firstVehicle?.vehicleId?.make, firstVehicle?.vehicleId?.model].filter(Boolean).join(" ") ||
              "-";
            const firstVehicleFuelType =
              firstVehicle?.snapshot?.fuelType || firstVehicle?.vehicleId?.fuelType || "-";
            const firstVehicleSeats =
              firstVehicle?.snapshot?.specifications?.seatingCapacity ||
              firstVehicle?.vehicleId?.specifications?.seatingCapacity ||
              "-";
            const totalVehicleQty = bookingVehicles.reduce(
              (sum, vehicle) => sum + (Number(vehicle?.quantity) || 0),
              0
            );

            const driverAssignments = Array.isArray(booking?.driverAssignments) ? booking.driverAssignments : [];
            const firstDriverAssignment = driverAssignments[0] || null;
            const firstDriver = firstDriverAssignment?.driverSnapshot || firstDriverAssignment?.driverId || null;
            const firstDriverLabel = firstDriver?.name || "-";

            return (
              <tr
                key={booking?._id || `${booking?.customerId?._id || booking?.customerId}-${booking?.createdAt}`}
                onClick={() => onViewDetails(booking)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onViewDetails(booking);
                  }
                }}
                role="button"
                tabIndex={0}
                style={{ cursor: "pointer" }}
              >
                <td>
                  <div className="fw-semibold">{customerName}</div>
                  <small className="text-muted d-block">Booking: {displayBookingId}</small>
                  <small className="text-muted d-block">{companyName}</small>
                  <small className="text-muted d-block">{customerPhone}</small>
                </td>

                <td>
                  <div className="fw-semibold">{firstVehicleLabel}</div>
                  <small className="text-muted d-block">
                    {`Fuel: ${firstVehicleFuelType} | Seats: ${firstVehicleSeats}`}
                  </small>
                  <small className="text-muted d-block">
                    {bookingVehicles.length} type(s), {totalVehicleQty || bookingVehicles.length} unit(s)
                  </small>
                </td>

                <td>
                  <div className="fw-semibold">{firstDriverLabel}</div>
                  <small className="text-muted d-block">
                    {driverAssignments.length > 0
                      ? `${driverAssignments.length} assignment(s)`
                      : "Not assigned"}
                  </small>
                </td>

                <td>
                  <div className="fw-semibold">{booking?.pickupLocation || "-"}</div>
                  <small className="text-muted d-block">to {booking?.dropoffLocation || "-"}</small>
                </td>
                <td>{formatBookingAmount(booking?.totalAmount)}</td>

                <td>
                  <span className={getBookingStatusBadgeClass(booking?.status)}>
                    {(booking?.status || "unknown").replace("_", " ")}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BookingsTable;
